import {useEffect, useState} from 'react';

export const useLoadI18 = (): boolean => {
  const [i18Loaded, setI18Loaded] = useState(false);

  useEffect(() => {
    window.PMW.initI18next(window.PMW.LANGUAGE, () => {
      setI18Loaded(true);
    });
    window.PMW.initTracking();
  }, []);

  return i18Loaded;
};
